// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1LCe-","label":"styles_label__1h8Mc"};